"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WishlistContextProvider = exports.useWishlist = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireWildcard(require("react"));
var _agent = require("@deosite/agent");
var _TokenProvider = require("../common/TokenProvider");
var _LanguageProvider = require("../common/LanguageProvider");
var _MessageHandlerProvider = require("../common/MessageHandlerProvider");
var _useProductsBySkus = require("./useProductsBySkus");
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _CartProvider = require("./CartProvider");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
var WishlistContext = /*#__PURE__*/_react["default"].createContext();
var WishlistContextProvider = function WishlistContextProvider(props) {
  var _useState = (0, _react.useState)(),
    wishlistSkus = _useState[0],
    setWishlistSkus = _useState[1];
  var _useState2 = (0, _react.useState)([]),
    wishlistProducts = _useState2[0],
    setWishlistProducts = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    wishlistLoading = _useState3[0],
    setWishlistLoading = _useState3[1];
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var _useToken = (0, _TokenProvider.useToken)(),
    token = _useToken.token;
  var _useHandleMessage = (0, _MessageHandlerProvider.useHandleMessage)(),
    handleMessage = _useHandleMessage.handleMessage;
  var _useCart = (0, _CartProvider.useCart)(),
    addProduct = _useCart.addProduct;
  var wishlistEndpoint = "https://".concat(language.domain, "/").concat(global.__appConfig__.wishlistEndpointUrl, "/");
  var translations = {
    addedToWishlist: (0, _langLibrary["default"])("Added to wishlist"),
    removedFromWishlist: (0, _langLibrary["default"])("Removed from wishlist")
  };
  (0, _react.useEffect)(function () {
    var _sessionStorage;
    var isCanceled = false;
    var fetchWishlistSkus = /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var wishList;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(wishlistSkus === undefined)) {
                  _context.next = 11;
                  break;
                }
                _context.prev = 1;
                _context.next = 4;
                return _agent.requests.getExternal(wishlistEndpoint, false, token);
              case 4:
                wishList = _context.sent;
                if (!isCanceled) {
                  setWishlistSkus(wishList.skus);
                  sessionStorage.setItem("wishlist", JSON.stringify(wishList.skus));
                }
                _context.next = 11;
                break;
              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                handleMessage(_context.t0);
              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 8]]);
      }));
      return function fetchWishlistSkus() {
        return _ref.apply(this, arguments);
      };
    }();
    var storedWishlist = (_sessionStorage = sessionStorage) === null || _sessionStorage === void 0 ? void 0 : _sessionStorage.getItem("wishlist");
    if (token) {
      if (storedWishlist) {
        setWishlistSkus(JSON.parse(storedWishlist));
      } else {
        fetchWishlistSkus().then();
      }
    } else {
      sessionStorage.removeItem("wishlist");
      setWishlistSkus(undefined);
    }
    return function () {
      isCanceled = true;
    };
  }, [token]);
  (0, _react.useEffect)(function () {
    var isCanceled = false;
    var getProducts = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(skusToFetch) {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return (0, _useProductsBySkus.fetcher)({
                  skus: skusToFetch,
                  pageSize: 1000,
                  language: language
                });
              case 3:
                return _context2.abrupt("return", _context2.sent);
              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](0);
                console.log(_context2.t0);
                return _context2.abrupt("return", []);
              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 6]]);
      }));
      return function getProducts(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    if (!wishlistSkus) {
      setWishlistProducts([]);
      return;
    }
    if (wishlistProducts.length === 0) {
      getProducts(wishlistSkus).then(function (result) {
        if (!isCanceled) {
          setWishlistProducts(result);
        }
      });
    } else if (wishlistSkus.length > wishlistProducts.length) {
      getProducts(wishlistSkus[wishlistSkus.length - 1]).then(function (result) {
        if (!isCanceled) {
          setWishlistProducts(function (currentProducts) {
            return [].concat((0, _toConsumableArray2["default"])(currentProducts), [result[0]]);
          });
        }
      });
    } else {
      var productsToSave = wishlistProducts.filter(function (product) {
        return wishlistSkus.includes(product.sku);
      });
      setWishlistProducts(productsToSave);
    }
    return function () {
      isCanceled = true;
    };
  }, [wishlistSkus]);
  var addToWishlist = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(sku) {
      var newList;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return _agent.requests.postExternal(wishlistEndpoint + sku, false, token);
            case 3:
              newList = [].concat((0, _toConsumableArray2["default"])(wishlistSkus), [sku]);
              setWishlistSkus(newList);
              sessionStorage.setItem("wishlist", JSON.stringify(newList));
              handleMessage(translations.addedToWishlist, false, false);
              _context3.next = 12;
              break;
            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](0);
              handleMessage(_context3.t0);
            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 9]]);
    }));
    return function addToWishlist(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var removeFromWishlist = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(sku) {
      var newList;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return _agent.requests.delExternal(wishlistEndpoint + sku, false, token);
            case 3:
              newList = wishlistSkus.filter(function (id) {
                return id !== sku;
              });
              setWishlistSkus(newList);
              sessionStorage.setItem("wishlist", JSON.stringify(newList));
              handleMessage(translations.removedFromWishlist, false, true);
              _context4.next = 12;
              break;
            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](0);
              handleMessage(_context4.t0);
            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 9]]);
    }));
    return function removeFromWishlist(_x3) {
      return _ref4.apply(this, arguments);
    };
  }();
  var addWholeWishlistToCart = /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(currentPage, pageSize) {
      var addSingle, skusFiltered, skusFilteredPromises;
      return _regenerator["default"].wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              addSingle = /*#__PURE__*/function () {
                var _ref6 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(sku) {
                  return _regenerator["default"].wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _context5.prev = 0;
                          _context5.next = 3;
                          return addProduct({
                            sku: sku
                          }, 1);
                        case 3:
                          return _context5.abrupt("return", _context5.sent);
                        case 6:
                          _context5.prev = 6;
                          _context5.t0 = _context5["catch"](0);
                          console.log(_context5.t0);
                          return _context5.abrupt("return");
                        case 10:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5, null, [[0, 6]]);
                }));
                return function addSingle(_x6) {
                  return _ref6.apply(this, arguments);
                };
              }();
              skusFiltered = wishlistSkus === null || wishlistSkus === void 0 ? void 0 : wishlistSkus.filter(function (_, index) {
                return index >= currentPage * pageSize - pageSize && index < currentPage * pageSize;
              });
              skusFilteredPromises = skusFiltered.map(addSingle);
              _context6.next = 5;
              return Promise.all(skusFilteredPromises);
            case 5:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
    return function addWholeWishlistToCart(_x4, _x5) {
      return _ref5.apply(this, arguments);
    };
  }();
  return __jsx(WishlistContext.Provider, {
    value: {
      accountWishlist: wishlistSkus,
      wishlistProducts: wishlistProducts,
      setWishlistSkus: setWishlistSkus,
      wishlistLoading: wishlistLoading,
      setWishlistLoading: setWishlistLoading,
      addWholeWishlistToCart: addWholeWishlistToCart,
      addToWishlist: addToWishlist,
      removeFromWishlist: removeFromWishlist
    }
  }, props.children);
};
exports.WishlistContextProvider = WishlistContextProvider;
var useWishlist = function useWishlist() {
  return (0, _react.useContext)(WishlistContext);
};
exports.useWishlist = useWishlist;